/**
 * This module is to load scripts in NHS site.
 * The idea is to use the tag <script-component></script-component> to download this resource.
 *
 * The attributes supported are:
 * src: where the resource URL is downloaded.
 * strategy:  when to load your.
 *
 * Strategies that can be used:
 * lazyOnload: Load during idle time
 *
 * Example:
 * <script-component src="main.js" strategy="lazyOnload">
 *
 */
(function scriptComponent(global) {
  'use strict';

  /**
   * Class represeting a script tag.
   */
  class ScriptComponent extends HTMLElement {
    /**
     * loadScript: fetch the script to download.
     */
    loadScript() {
      const script = document.createElement('script');
      script.src = this.getAttribute('src');
      script.defer = true;
      document.body.appendChild(script);
      script.remove();
    }

    /**
     * lazyOnload: download the script after document is complete.
     */
    lazyOnload() {
      if (document.readyState === 'complete') {
        setTimeout(() => {
          this.loadScript.call(this);
        }, 0);
      } else {
        global.addEventListener('load', () => {
          setTimeout(() => {
            this.loadScript.call(this);
          }, 0);
        });
      }
    }

    /**
     * connectedCallback: Executed each time the tag is inserted.
     */
    connectedCallback() {
      const strategy = this.getAttribute('strategy');
      if (this[strategy]) {
        this[strategy]();
        return;
      }

      this.loadScript();
    }
  }

  if (global.customElements && !global.customElements.get('script-component')) {
    global.customElements.define('script-component', ScriptComponent);
  }
}(window));
